import { useRecoilValue } from 'recoil'
import dashboardGroupsAtom from '@/pages/Dashboards/dashboard.groups.atom.ts'

const useDashboardGroups = () => {
  const items = useRecoilValue(dashboardGroupsAtom).items

  return { groups: items }
}

export default useDashboardGroups
